module.exports = __webpack_public_path__ + "components/home-header/static/header-1--huge-369468113e712b87a2c8208685610988.jpg";